import ContinuousViewPlugin from './ContinuousViewPlugin';

export default ContinuousViewPlugin;
